export const GET_DATA = 'GET_DATA'; 
export const DATA_ERROR = 'DATA_ERROR';

